import React from 'react';
import PropTypes from 'prop-types';

import Button, {GreyButton} from 'components/Button';
import Page from 'components/Page';
import Footer from 'components/Footer';
import DealMetrics from 'components/DealMetrics';

import './DealSummary.css';

// TODO: sanitise description HTML

const DealSummary = ({next, deal, nextButtonText}) => (
  <section className="widerPageContainer">
    <h1>{deal.name}</h1>
    <Page>
      <section styleName="container">
        <aside styleName="left">
          <img styleName="picture" src={deal.image} alt="Flavourful" />
          <DealMetrics deal={deal} />
          <GreyButton
            onClick={() => {
              window.open(deal.memo.link);
            }}
            style={{margin: '0.5em 0'}}
          >
            View Investment Memo
          </GreyButton>
          <GreyButton
            onClick={() => {
              window.open(deal.model.link);
            }}
            style={{margin: '0.5em 0'}}
          >
            View Financial Model
          </GreyButton>
        </aside>
        <section
          styleName="right"
          className="content"
          dangerouslySetInnerHTML={{__html: atob(deal.description)}}
        />
      </section>
      <Footer border>
        <Button onClick={next} data-test="summary_invest">
          {nextButtonText}
        </Button>
      </Footer>
    </Page>
  </section>
);

DealSummary.propTypes = {
  next: PropTypes.func.isRequired,
  deal: PropTypes.object.isRequired,
  nextButtonText: PropTypes.string.isRequired,
};

export default DealSummary;



// WEBPACK FOOTER //
// ./web/components/DealSummary.js